import { useMutation, useQueryClient } from '@tanstack/react-query';

import queryKeys from '@pray/shared/queryKeys';
import api from '@pray/shared/utils/api';

import type { DeleteChatbotParams } from './types';

export async function deleteChatbot({ artistId }: DeleteChatbotParams): Promise<void> {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/chatbot`;
  await api.executeDeleteRequest(url);
}

export function useDeleteChatbot() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: deleteChatbot,
    onSuccess: (_, { artistId }) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.artistChatbot(artistId),
      });
    },
  });

  const { mutateAsync, ...rest } = mutation;

  return {
    deleteChatbot: mutateAsync,
    ...rest,
  };
}
